











import {defineComponent} from '@vue/composition-api'

export default defineComponent({
    name: "ButtonAtom",
    props: {
        type: {
            type: String,
            default: 'button',
            validator: (value: string) => {
                return ['button', 'submit', 'reset'].includes(value)
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disabledClass: {
            type: String,
            default: 'vuw-disabled'
        }
    }
})
